import React from 'react';
import { useQuery } from 'react-fetching-library';
import Page from '../../components/Page';
import { Card, CardContent } from '@mui/material';
import AddDocument from '../../sections/employee/essential-document/AddDocument';
import EssentialDocumentList from '../../sections/employee/essential-document/EssentialDocumentList';

import { getEssentialDocumentsAction } from '../../services/request';

export default function EssentialDocument () {
  const [search, setSearch] = React.useState(null);
  const [documents, setDocuments] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [count, setCount] = React.useState(0);
  const { loading, payload, error, query } = useQuery(getEssentialDocumentsAction('GET', search, page, pageSize));


  const queryCallback = data => {
    setSearch(data.search);
    query('GET', search, data.page, pageSize);
  };

  React.useEffect(() => {
    if (!loading && !error) {
      setDocuments(payload.results);
      setCount(payload.count);
    }
  }, [loading]);

  return (
    <Page title="Niezbędniki">
      <Card>
        <CardContent>
          <>
            <AddDocument setDocuments={setDocuments} />
            <EssentialDocumentList
              documents={documents}
              queryCallback={queryCallback}
              setDocuments={setDocuments}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              count={count}
              setCount={setCount}
            />
          </>
        </CardContent>
      </Card>
    </Page>
  );
};
